module.exports = __webpack_public_path__ + "img/TE_Estate_sjkfhkjhrj_4.a25ec28b.jpeg";